export default ({request}) => ({
  mastePortListApi(data = {}) {
    return request({
      url: '/master/port/list',
      method: 'post',
      data,
    })
  },
  mastePortDetailApi(data = {}) {
    return request({
      url: '/master/port/detail',
      method: 'post',
      data,
    })
  },
  mastePortSaveApi(data = {}) {
    return request({
      url: '/master/port/save',
      method: 'post',
      data,
    })
  },
  mastePortDelApi(data = {}) {
    return request({
      url: '/master/port/del',
      method: 'post',
      data,
    })
  },
})
